// 1. Create a new LazyFooterWrapper.tsx
import React, { useState, useEffect, useRef } from 'react';
import Footer from './Footer'; // Keep original import for type reference

export const LazyFooterWrapper = () => {
  const [isInView, setIsInView] = useState(false);
  const placeholderRef = useRef<HTMLDivElement>(null);
  const LazyFooter = React.lazy(() => import('./Footer'));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        root: null,
        rootMargin: '0px', // Load 200px before component enters viewport
        threshold: 0.01
      }
    );

    if (placeholderRef.current) {
      observer.observe(placeholderRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={placeholderRef}>
      {isInView && (
        <React.Suspense fallback={<FooterPlaceholder />}>
          <LazyFooter />
        </React.Suspense>
      )}
    </div>
  );
};

const FooterPlaceholder = () => (
  <div style={{ height: '300px', background: '#2B2B2B' }} />
);